/**
 * Admin Page Tour Configuration
 * Guided tour for tool management and maker onboarding
 */

export const ADMIN_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Admin Dashboard ⚙️',
    description: 'Manage tools, onboard makers, and control what users see in the AI Garage catalog.',
    position: 'center'
  },
  {
    id: 'tabs',
    title: 'Admin Sections',
    description: 'Manage tools, users, configuration, ROI, and product feedback from these tabs.',
    element: '[data-tour="admin-tabs"]',
    position: 'bottom',
    spotlight: true
  },
  {
    id: 'add-tool',
    title: 'Adding New Tools',
    description: 'Create new tool entries with all metadata before publishing. Fill in title, description, makers, and classification.',
    element: '[data-tour="admin-add-tool"]',
    position: 'left',
    spotlight: true
  },
  {
    id: 'publish-action',
    title: 'Publishing & Unpublishing',
    description: 'Publish to make a tool visible to all users. Unpublish to hide it temporarily. Always review before publishing!',
    element: '[data-tour="admin-tool-actions"]',
    position: 'left',
    spotlight: true
  },
  {
    id: 'maker-tab',
    title: 'Users and Admins',
    description: 'Full admins can manage user access roles from the Users & Admins tab.',
    element: '[data-tour="admin-users-tab"]',
    position: 'right',
    spotlight: true
  }
];
